<template lang="html">
  <v-container>
    <v-layout justify-center>
      <v-flex lg6 md8 sm8 xs12>
        <v-card>
          <v-card-title>Server-Einstellungen</v-card-title>
          <v-card-text>
            <v-text-field
              label="Server-Name"
              v-model="serverInfo.virtualserverName"
              :disabled="$store.state.query.loading"
            ></v-text-field>
            <v-text-field
              label="Passwort"
              v-model="serverInfo.virtualserverPassword"
              :disabled="$store.state.query.loading"
              type="password"
            ></v-text-field>
            <v-layout justify-space-between>
              <v-flex xs5>
                <v-text-field
                  label="Max. Benutzer"
                  v-model="serverInfo.virtualserverMaxclients"
                  :disabled="$store.state.query.loading"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  label="Reservierte Plätze"
                  v-model="serverInfo.virtualserverReservedSlots"
                  :disabled="$store.state.query.loading"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-textarea
              label="Willkommensnachricht"
              v-model="serverInfo.virtualserverWelcomemessage"
              :disabled="$store.state.query.loading"
            ></v-textarea>

            <v-expansion-panels accordion flat>
              <v-expansion-panel>
                <v-expansion-panel-header> Host </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card outlined>
                    <v-card-subtitle>Host-Nachricht</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Nachricht"
                        v-model="serverInfo.virtualserverHostmessage"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-select
                        label="Anzeigeart"
                        v-model="serverInfo.virtualserverHostmessageMode"
                        :items="messageModes"
                      ></v-select>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-2" outlined>
                    <v-card-subtitle>Host-Banner</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Banner-Bild-URL"
                        v-model="serverInfo.virtualserverHostbannerGfxUrl"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-text-field
                        label="URL"
                        v-model="serverInfo.virtualserverHostbannerUrl"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-layout justify-space-between>
                        <v-flex xs4>
                          <v-text-field
                            label="Bild-Intervall (Sek.)"
                            v-model="
                              serverInfo.virtualserverHostbannerGfxInterval
                            "
                            type="number"
                            :disabled="$store.state.query.loading"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            label="Größe anpassen"
                            :items="bannerModes"
                            v-model="serverInfo.virtualserverHostbannerMode"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-card class="my-2" outlined>
                    <v-card-subtitle>Host-Button</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Hinweistext"
                        v-model="serverInfo.virtualserverHostbuttonTooltip"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-text-field
                        label="URL"
                        v-model="serverInfo.virtualserverHostbuttonUrl"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-text-field
                        label="Symbol-URL"
                        v-model="serverInfo.virtualserverHostbuttonGfxUrl"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header> Dateiübertragung </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card outlined>
                    <v-card-subtitle>Hochladen</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Max. Bandbreite"
                        v-model="
                          serverInfo.virtualserverMaxUploadTotalBandwidth
                        "
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>Byte/s</div>
                        </template>
                      </v-text-field>
                      <v-text-field
                        label="Kontingent Hochladen"
                        v-model="serverInfo.virtualserverUploadQuota"
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>MiB</div>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                  <v-card class="my-2" outlined>
                    <v-card-subtitle>Herunterladen</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Max. Bandbreite"
                        v-model="
                          serverInfo.virtualserverMaxDownloadTotalBandwidth
                        "
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>Byte/s</div>
                        </template>
                      </v-text-field>
                      <v-text-field
                        label="Kontingent Herunterladen"
                        v-model="serverInfo.virtualserverDownloadQuota"
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>MiB</div>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Flood-Schutz
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mb-2" outlined>
                    <v-card-text>
                      <v-text-field
                        label="Punkte-Abbau pro Tick"
                        v-model="
                          serverInfo.virtualserverAntifloodPointsTickReduce
                        "
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Punkte, ab denen Befehle gesperrt werden"
                        v-model="
                          serverInfo.virtualserverAntifloodPointsNeededCommand_block
                        "
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Punkte, ab denen die IP gesperrt wird"
                        v-model="
                          serverInfo.virtualserverAntifloodPointsNeededIp_block
                        "
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header> Sicherheit </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mb-2" outlined>
                    <v-card-text>
                      <v-text-field
                        label="Benötigte Sicherheitsstufe"
                        v-model="
                          serverInfo.virtualserverNeededIdentitySecurityLevel
                        "
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                      <v-select
                        label="Verschlüsselung der Sprache in Kanälen"
                        v-model="serverInfo.virtualserverCodecEncryptionMode"
                        :items="encryptionModes"
                      ></v-select>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header> Sonstiges </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card outlined>
                    <v-card-subtitle>Standard-Gruppen</v-card-subtitle>
                    <v-card-text>
                      <v-autocomplete
                        :items="serverGroups"
                        item-text="name"
                        item-value="sgid"
                        v-model="serverInfo.virtualserverDefaultServerGroup"
                        label="Server-Gruppe"
                        :disabled="$store.state.query.loading"
                      >
                        <template #selection="{ item }">
                          <div>{{ item.name }} ({{ item.sgid }})</div>
                        </template>
                        <template #item="{ item }">
                          <div>{{ item.name }} ({{ item.sgid }})</div>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        :items="channelGroups"
                        item-text="name"
                        item-value="cgid"
                        v-model="serverInfo.virtualserverDefaultChannelGroup"
                        label="Kanal-Gruppe"
                        :disabled="$store.state.query.loading"
                      >
                        <template #selection="{ item }">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                        <template #item="{ item }">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        :items="channelGroups"
                        item-text="name"
                        item-value="cgid"
                        v-model="
                          serverInfo.virtualserverDefaultChannelAdminGroup
                        "
                        label="Kanal-Admin-Gruppe"
                        :disabled="$store.state.query.loading"
                      >
                        <template #selection="{ item }">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                        <template #item="{ item }">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                      </v-autocomplete>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-2" outlined>
                    <v-card-subtitle>Beschwerden</v-card-subtitle>
                    <v-card-text>
                      <v-layout justify-space-between wrap>
                        <v-flex xs5 md3>
                          <v-text-field
                            label="Auto-Bann ab Anzahl"
                            :disabled="$store.state.query.loading"
                            v-model="
                              serverInfo.virtualserverComplainAutobanCount
                            "
                            type="number"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md3>
                          <v-text-field
                            label="Auto-Bann-Dauer"
                            :disabled="$store.state.query.loading"
                            v-model="
                              serverInfo.virtualserverComplainAutobanTime
                            "
                            type="number"
                          >
                            <template #append>
                              <div>Sek.</div>
                            </template>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs5 md3>
                          <v-text-field
                            label="Löschen nach"
                            :disabled="$store.state.query.loading"
                            v-model="
                              serverInfo.virtualserverComplainRemoveTime
                            "
                            type="number"
                          >
                            <template #append>
                              <div>Sek.</div>
                            </template>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-card class="my-2" outlined>
                    <v-card-text>
                      <v-text-field
                        label="Min. Benutzer im Kanal vor erzwungener Stille"
                        :disabled="$store.state.query.loading"
                        v-model="
                          serverInfo.virtualserverMinClientsInChannel_beforeForcedSilence
                        "
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Dämpfung bei Vorrang-Sprecher"
                        :disabled="$store.state.query.loading"
                        v-model="
                          serverInfo.virtualserverPrioritySpeakerDimmModificator
                        "
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Löschverzögerung für temporäre Kanäle"
                        :disabled="$store.state.query.loading"
                        v-model="
                          serverInfo.virtualserverChannelTempDeleteDelay_default
                        "
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Phonetischer Name"
                        :disabled="$store.state.query.loading"
                        v-model="serverInfo.virtualserverNamePhonetic"
                      ></v-text-field>
                      <v-checkbox
                        label="In der öffentlichen Server-Liste anzeigen"
                        v-model="weblistEnabled"
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header> Protokoll </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mb-2" outlined>
                    <v-card-subtitle>Ins Protokoll schreiben</v-card-subtitle>
                    <v-card-text>
                      <v-checkbox
                        label="Benutzer"
                        v-model="logClient"
                      ></v-checkbox>
                      <v-checkbox
                        label="Kanäle"
                        v-model="logChannel"
                      ></v-checkbox>
                      <v-checkbox
                        label="Server"
                        v-model="logServer"
                      ></v-checkbox>
                      <v-checkbox
                        label="ServerQuery"
                        v-model="logQuery"
                      ></v-checkbox>
                      <v-checkbox
                        label="Rechte"
                        v-model="logPermissions"
                      ></v-checkbox>
                      <v-checkbox
                        label="Dateiübertragung"
                        v-model="logFileTransfer"
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="this.$store.state.query.loading"
              color="primary"
              @click="saveChanges"
              >OK
            </v-btn>
            <v-btn text @click="$router.go(-1)" color="primary">Abbrechen</v-btn>
            <v-btn
              text
              :disabled="this.$store.state.query.loading"
              color="primary"
              @click="applyChanges"
              >Übernehmen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      serverInfo: {},
      serverInfoCopy: {},
      messageModes: [
        { text: "Keine Nachricht", value: 0 },
        { text: "Im Chat-Verlauf anzeigen", value: 1 },
        { text: "Als Fenster anzeigen", value: 2 },
        { text: "Als Fenster anzeigen und trennen", value: 3 },
      ],
      bannerModes: [
        { text: "Nicht anpassen", value: 0 },
        { text: "Anpassen, Seitenverhältnis ignorieren", value: 1 },
        { text: "Anpassen, Seitenverhältnis beibehalten", value: 2 },
      ],
      encryptionModes: [
        { text: "Je Kanal einstellen", value: 0 },
        { text: "Überall aus", value: 1 },
        { text: "Überall an", value: 2 },
      ],
      serverGroups: [],
      channelGroups: [],
    };
  },
  computed: {
    weblistEnabled: {
      get() {
        return this.serverInfo.virtualserverWeblistEnabled ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverWeblistEnabled = bool ? 1 : 0;
      },
    },
    logClient: {
      get() {
        return this.serverInfo.virtualserverLogClient ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverLogClient = bool ? 1 : 0;
      },
    },
    logQuery: {
      get() {
        return this.serverInfo.virtualserverLogQuery ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverLogQuery = bool ? 1 : 0;
      },
    },
    logChannel: {
      get() {
        return this.serverInfo.virtualserverLogChannel ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverLogChannel = bool ? 1 : 0;
      },
    },
    logPermissions: {
      get() {
        return this.serverInfo.virtualserverLogPermissions ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverLogPermissions = bool ? 1 : 0;
      },
    },
    logServer: {
      get() {
        return this.serverInfo.virtualserverLogServer ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverLogServer = bool ? 1 : 0;
      },
    },
    logFileTransfer: {
      get() {
        return this.serverInfo.virtualserverLogFiletransfer ? true : false;
      },
      set(bool) {
        this.serverInfo.virtualserverLogFiletransfer = bool ? 1 : 0;
      },
    },
  },
  methods: {
    getServerInfo() {
      return this.$TeamSpeak.execute("serverinfo").then((arr) => arr[0]);
    },
    getServerGroupList() {
      return this.$TeamSpeak
        .execute("servergrouplist")
        .then((groups) => groups.filter((group) => group.type === 1));
    },
    getChannelGroupList() {
      return this.$TeamSpeak
        .execute("channelgrouplist")
        .then((groups) => groups.filter((group) => group.type === 1));
    },
    getChanges() {
      let changes = {};

      for (let prop in this.serverInfo) {
        if (this.serverInfo[prop] !== this.serverInfoCopy[prop]) {
          changes[prop] = this.serverInfo[prop];
        }
      }

      return changes;
    },
    serverEdit() {
      return this.$TeamSpeak.execute("serveredit", this.getChanges());
    },
    async saveChanges() {
      try {
        await this.serverEdit();

        this.$router.go(-1);
      } catch (err) {
        this.$toast.error(err.message);
      }
    },
    async applyChanges() {
      try {
        await this.serverEdit();
      } catch (err) {
        this.$toast.error(err.message);
      }

      this.init();
    },
    async init() {
      try {
        this.serverInfo = await this.getServerInfo();
        this.serverInfoCopy = { ...this.serverInfo };
        this.serverGroups = await this.getServerGroupList();
        this.channelGroups = await this.getChannelGroupList();
      } catch (err) {
        this.$toast.error(err.message);
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
